import { TypeKind } from '@Common/Enums/Enum';

export const inputType = {
    string: TypeKind.string,
    bool: TypeKind.bool,
    guid: TypeKind.guid,
    dateTime: TypeKind.dateTime,
    float: TypeKind.float,
    int: TypeKind.int,
    text: TypeKind.text,
    url: 'url',
    timeSpan: 'timeSpan'
};
